export default __webpack_public_path__ + "static/portfolio_jayyogeshwar-b5f67237734150cc2027935c9df6054e.png";